module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton5.bea1a175.jpg";